import LoadingSpinner from "../../components/GlobalLoading";
import {
  CHECK_STATUS_CONSTANTS,
  SEARCH_STATUS_TABS,
  useExportConstData,
} from "./homeData";
import Header from "./components/header";
import ClaimStatus from "./components/claimStatus";
import PolicyStatus from "./components/policyStatus";
import Footer from "./components/Footer";

import "./index.scss";

const HomePage = () => {
  const { activeTab, setActiveTab, isLoading, setIsLoading } =
    useExportConstData();

  return (
    <div className="home">
      <div className="home__container">
        <Header />

        <div className="home__tab-wrapper">
          {SEARCH_STATUS_TABS.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`home__tab-button ${
                activeTab === tab.id ? "home__tab-button--active" : ""
              }`}
            >
              {tab?.label.toUpperCase()}
            </button>
          ))}
        </div>

        {activeTab === CHECK_STATUS_CONSTANTS.CLAIM_STATUS ? (
          <ClaimStatus setIsLoading={setIsLoading} />
        ) : (
          <PolicyStatus setIsLoading={setIsLoading} />
        )}
      </div>

      <LoadingSpinner open={isLoading} />

      <Footer />
    </div>
  );
};

export default HomePage;
